<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Rutas</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/transportec/routes" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="route">
    <div class="ride">
      <ion-img class="photo" [src]="route.icon" *ngIf="route.icon"></ion-img>
      <ion-img class="photo" [src]="route.image" *ngIf="!route.icon && route.image"></ion-img>
      <div class="description">
        <div class="text">
          <h4>{{route.name}}</h4>
          <p>{{route.description}}</p>
          <p>Paradas: {{route.stops.length}}</p>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <section id="cd-timeline" *ngIf="route">
    <div *ngFor="let stop of route.stops; let last = last; let first = first; let i = index;" class="cd-container">
      <div [class]="last?'cd-timeline-last-block':'cd-timeline-block'">
        <div class="cd-timeline-icon">
          <ion-icon class="appname-expresotec" [color]="first? 'warning':'primary'" hidden></ion-icon>
          <img [src]="route.icon" *ngIf="route.icon" />
          <img [src]="route.image" *ngIf="!route.icon && route.image" />
        </div>
        <div class="cd-timeline-content">
          <p class="timelineText" ion-text>{{stop.name}}</p>
          <img
            [src]="stop.image"
            *ngIf="!transportec && stop.showAll && stop.image"
            (click)="viewImage(stop?.image, stop?.name, '')"
          />
          <div *ngIf="!transportec">
            <p
              *ngFor="let timetable of stop.timetable;"
              class="timelineTimetable"
              [class.notToday]="today !== timetable.day && !stop.showAll"
            >
              {{timetable.day | dayOfWeek}} - {{timetable.time}}
            </p>
            <a (click)="stop.showAll = true" *ngIf="!stop.showAll && !transportec">Ver más</a>
            <a (click)="stop.showAll = false" *ngIf="stop.showAll && !transportec">Ver menos</a>
          </div>
          <div *ngIf="transportec">
            <p
              *ngFor="let timetable of stop.timetables;"
              class="timelineTimetable"
              [class.times]="today === timetable.day"
              [class.hideRest]="today !== timetable.day && !stop.showAll"
            >
              {{timetable.day | dayOfWeek}} - {{timetable.time}}
            </p>
            <a (click)="stop.showAll = true" *ngIf="!stop.showAll && transportec">Ver más</a>
            <a (click)="stop.showAll = false" *ngIf="stop.showAll && transportec">Ver menos</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</ion-content>
